<div class="account-management-container" (click)="closeAllDropdowns()">
  <!-- Page Title -->
  <p class="tab-title">{{ entityLabel }} Management</p>

  <!-- Current User Profile Section -->
  <div class="current-user-section">
    <div class="user-avatar">
      @if (isLoadingCurrentUser) {
        <ngx-skeleton-loader
          aria-hidden="true"
          appearance="line"
        [theme]="{
          width: '38px',
          height: '38px',
          borderRadius: '50%',
          margin: '0',
          display: 'block',
          lineHeight: '0'
        }"
          >
        </ngx-skeleton-loader>
      } @else {
        @if (currentUser?.avatarUrl) {
          <img [src]="currentUser.avatarUrl" class="avatar-image" />
        } @else {
          <span class="user-initials">{{ currentUser?.initials }}</span>
        }
      }
    </div>

    <div class="user-info">
      <div class="user-name-container">
        @if (isLoadingCurrentUser) {
          <ngx-skeleton-loader
            ariaLabel="Loading profile"
            appearance="line"
          [theme]="{
            width: '140px',
            height: '22px',
            borderRadius: '6px',
            margin: '0 0 4px 0',
            display: 'block',
            lineHeight: '0'
          }"
            >
          </ngx-skeleton-loader>
        } @else {
          <h2 class="user-name">{{ currentUser?.firstName }}</h2>
          <h2 class="user-name">{{ currentUser?.lastName }}</h2>
          <span [class]="'status-badge ' + statusClass">
            {{ currentUser?.status }}
          </span>
        }
      </div>

      <p class="user-position">
        @if (isLoadingCurrentUser) {
          <ngx-skeleton-loader
            aria-hidden="true"
            appearance="line"
          [theme]="{
            width: '160px',
            height: '17px',
            borderRadius: '6px',
            margin: '0',
            display: 'block',
            lineHeight: '0'
          }"
            >
          </ngx-skeleton-loader>
        } @else {
          {{ currentUser?.position }}
        }
      </p>

      <p class="user-role">
        @if (isLoadingCurrentUser) {
          <ngx-skeleton-loader
            aria-hidden="true"
            appearance="line"
          [theme]="{
            width: '300px',
            height: '17px',
            borderRadius: '6px',
            margin: '0',
            display: 'block',
            lineHeight: '0'
          }"
            >
          </ngx-skeleton-loader>
        } @else {
          {{ groupNames }}
        }
      </p>
    </div>
  </div>

  <!-- Accounts Section -->
  <div class="accounts-section">
    <!-- Section Header -->
    <div class="section-header">
      <div class="header-left">
        <h3 class="section-title">{{ entityLabel }}s ({{ totalCount() }})</h3>
        <app-button
          *appHasPermission="{ resource: Resources.Accounts, scope: Scopes.Create }"
          buttonVariant="accent-add"
          buttonType="button"
          (buttonClick)="onAddAccount()"
          >
          <mat-icon>add</mat-icon>
          <span class="text"> Add {{ entityLabel }} </span>
        </app-button>
      </div>

      <!-- Filter Controls -->
      <div class="filter-controls">
        <div class="filter-pills">
          <!-- Sort By Dropdown -->
          <app-pill-dropdown
            dropdownId="sort"
            [options]="sortOptionsLabels"
            [selectedOption]="selectedSortOption"
            (optionSelected)="onOptionSelected($event)"
            (cleared)="onCleared($event)"
            />

          <!-- Status Dropdown -->
          <app-pill-dropdown
            dropdownId="status"
            [options]="statusOptionsLabels"
            [selectedOption]="selectedStatusOption"
            (optionSelected)="onOptionSelected($event)"
            (cleared)="onCleared($event)"
            />

          <!-- Role Dropdown -->
          <app-pill-dropdown
            dropdownId="role"
            [options]="roleOptionsLabels"
            [selectedOption]="selectedRoleOption"
            (optionSelected)="onOptionSelected($event)"
            (cleared)="onCleared($event)"
            />
        </div>

        <!-- Search Field -->
        <app-pill-search [searchText]="searchTerm" placeholder="Search" (searchChange)="onSearchChange($event)" />
      </div>
    </div>

    <!-- Accounts Grid -->
    <div class="accounts-content">
      @if (!loading() && !initializing) {
        @if (filteredAccounts.length > 0) {
          <div class="accounts-list">
            <app-virtual-scroll [items]="filteredAccounts" size="account" [viewportHeight]="listViewportHeight('100%')">
              <ng-template let-account>
                <app-account-card [account]="account" (cardClick)="onAccountClick($event)" />
              </ng-template>
            </app-virtual-scroll>
          </div>
        } @else {
          <div class="empty-state">
            <div class="empty-state-card">
              <h3 class="empty-state-title">
                {{ 'No matching results' }}
              </h3>
            </div>
          </div>
        }
      } @else {
        <div class="loading-container">
          <app-loading-spinner size="large" [label]="`Loading ${entityLabel}s...`"></app-loading-spinner>
        </div>
      }
    </div>
  </div>
</div>
